import { Fragment, useEffect } from 'react';
import { Text } from '../../FormControls/Text';
import { Stack } from '../../FormControls/Stack';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { SetQr } from '../../FormControls/SetQr';
import { TimerLine } from '../../FormControls/TimerLine';
import { Button } from '../../FormControls/Button';
import { ArrowBackIos } from '@mui/icons-material';
import { jump } from "../../../../main/slices/routerSlice";

export const QrPage = ({ dimensions }) => {
    const stateTrx = useSelector(({ transaction }) => transaction);
    const dispatch = useDispatch();
    
    // Memoized Selectors (Avoid Re renders)
    const getId = (state) => state.id;
    const getCheck = (state) => state.exists;
    const getPassword = (state) => state.password;
    const initState = createSelector([getId, getPassword, getCheck], (id, password, exists) => ({ password, id, exists }))
    // Retrieve state whit Memoized Selectors
    const state = useSelector(({ user }) => initState(user));

    return (
        <>
        <Fragment>
            <div style={{ padding: "0 1.5rem" }}>
                <Stack
                    sx={{ ...dimensions }}
                    flex={{
                        flexDirection: "column",
                        alignContent: "center",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <Text classes={["title", "center", "left"]}> Escanea el QR desde tu World App para realizar el pago </Text>
                    <div style={{ marginBottom: "2rem" }}></div>
                    <Text classes={["subtitle", "center", "left"]}> Monto aproximado a pagar {stateTrx.total.value} WLD </Text>
                    <div style={{ marginBottom: "1rem" }}></div>
                    <SetQr
                        qr={stateTrx.qrPayment.value}
                    ></SetQr>
                    <div style={{ marginBottom: "4rem" }}></div>
                    <TimerLine></TimerLine>
                </Stack>
            </div>
        </Fragment >
        <Button 
            style={{
                position: "fixed",
                top: "1.5rem",
            }} 
            classes={["btnBackward", "alignBtnContent", "purpleBtn"]} 
            onClick={() => dispatch(jump({ current: 8, direction: "backward" })) }
        >
            <ArrowBackIos />
        </Button>
        </>
    );
}